var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 37C30.2843 37 37 30.2843 37 22C37 13.7157 30.2843 7 22 7C13.7157 7 7 13.7157 7 22C7 30.2843 13.7157 37 22 37ZM22 39C31.3888 39 39 31.3888 39 22C39 12.6112 31.3888 5 22 5C12.6112 5 5 12.6112 5 22C5 31.3888 12.6112 39 22 39Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22C25 23.6569 23.6569 25 22 25C20.3431 25 19 23.6569 19 22C19 20.3431 20.3431 19 22 19C23.6569 19 25 20.3431 25 22Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5327 10.6006L29.2648 11.6006L22.995 22.4602L21.2629 21.4602L27.5327 10.6006Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23L13 21L23 21L23 23L13 23Z",
    fill: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H10V23H7V21Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 21H37V23H34V21Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H23V10H21V7Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34H23V37H21V34Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.94fd7f4890d5ab890046fd0ff0dbdc3d.svg";
export { ForwardRef as ReactComponent };